var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeminino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_2_1",
    "data-name": "Componente 2 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_150",
    "data-name": "Elipse 150",
    fill: "#343131",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-female",
    "data-name": "Icon ionic-md-female",
    d: "M28.125,12.375a10.125,10.125,0,1,0-11.812,9.984v3.516H11.25V29.25h5.063v4.5h3.375v-4.5H24.75V25.875H19.688V22.359A10.123,10.123,0,0,0,28.125,12.375Zm-16.875,0A6.75,6.75,0,1,1,18,19.125,6.761,6.761,0,0,1,11.25,12.375Z",
    transform: "translate(6 6.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeminino);
export default __webpack_public_path__ + "static/media/feminino.54a41d660159f64cbc3d793b1826b559.svg";
export { ForwardRef as ReactComponent };